import React from "react";
import { Info, Truck, ShieldCheck, Headphones } from "lucide-react";
import { StaticPage, Block } from "../components/StaticPage";

const AboutPage = () => (
  <StaticPage icon={Info} title="À propos de nous" testid="about-page"
    intro="KTSauto, votre expert français de la pièce auto au meilleur prix.">
    <Block title="Notre mission">
      <p>Depuis notre atelier de Tours, KTSauto rend l'entretien et la réparation automobile accessibles à tous.
      Nous sélectionnons des milliers de références de grandes marques (Bosch, Valeo, Sachs, Mann-Filter…) pour vous
      offrir des pièces fiables, au juste prix et livrées rapidement partout en France.</p>
    </Block>
    <Block title="Pourquoi nous choisir ?">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
        <div className="bg-[#181C26] rounded-xl p-4 flex items-start gap-3"><Truck size={22} className="text-[#FF3B3B] shrink-0" /><div><div className="font-semibold text-slate-50">Livraison rapide</div><div className="text-[13px]">Expédition rapide, livraison offerte dès un certain montant.</div></div></div>
        <div className="bg-[#181C26] rounded-xl p-4 flex items-start gap-3"><ShieldCheck size={22} className="text-[#FF3B3B] shrink-0" /><div><div className="font-semibold text-slate-50">Pièces garanties</div><div className="text-[13px]">Uniquement des marques reconnues et certifiées.</div></div></div>
        <div className="bg-[#181C26] rounded-xl p-4 flex items-start gap-3"><Headphones size={22} className="text-[#FF3B3B] shrink-0" /><div><div className="font-semibold text-slate-50">Conseil expert</div><div className="text-[13px]">Une équipe de passionnés à votre écoute.</div></div></div>
      </div>
    </Block>
    <Block title="Nos chiffres">
      <p>Plus de 50 000 références en catalogue · 15 000 clients satisfaits · une note moyenne de 4,7/5 sur nos produits.</p>
    </Block>
  </StaticPage>
);

export default AboutPage;
